/**
 * Window CustomEvent that bridges the FontName command post-hook in
 * `commandHandler.js` to `useLayoutUsedFonts`, so a just-applied font folds
 * into the "Used in this layout" dropdown section without re-scanning every
 * page (#2435).
 *
 * Single-sourced here so the producer (dispatch) and consumer (listener) can't
 * drift on a magic string — a typo on either side would silently stop the
 * section from updating with no type error.
 */
export const TINYMCE_FONT_CHANGE_EVENT = 'tinymce:fontchange'

export type FontChangeEventDetail = {
  /** Raw CSS font-family applied — may be a fallback chain. */
  fontName: string
}
